import { AuditMatch, AuditSchedule } from '@mi-front/core';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import { Chip, Tooltip } from '@mui/material';
import { useIntl } from 'react-intl';
import { LTime } from '../../../../components/date/LTime';

export function ConfirmedBySchedule(p: { match: AuditMatch; schedule: AuditSchedule }) {
  const { $t } = useIntl();
  return (
    <Tooltip
      title={$t({
        id: 'audit.matchesWithSchedule',
        defaultMessage: 'Matches with schedule',
      })}
    >
      <Chip
        icon={<EventAvailableIcon />}
        label={<LTime value={p.schedule.datetime} />}
        size="small"
        component="a"
        href={`/audit/s/${p.schedule.stationId}/schedule/spot/${p.schedule.id}`}
        target="_blank"
        variant="outlined"
        color="success"
        clickable
      />
    </Tooltip>
  );
}
